<template>
    <div class="vehicle-info">
        <!-- 标题与生成时间 -->
        <div class="header">
            <h3>一、车辆基本信息：</h3>
            <span class="generate-time">生成时间：{{ reportTime }}</span>
        </div>

        <!-- 车辆信息描述列表 -->
        <el-descriptions :column="1" border size="middle" style="width: 100%;">
            <el-descriptions-item label="车牌号">{{ basicInfo.CarNo }}</el-descriptions-item>
            <el-descriptions-item label="电动机型号" v-if="fuelType === 1">{{ basicInfo.ElecMachineModel
            }}</el-descriptions-item>
            <el-descriptions-item label="发动机型号" v-if="fuelType === 2">{{ basicInfo.DeviceTypeName
            }}</el-descriptions-item>
            <el-descriptions-item label="终端编号">{{ basicInfo.DeviceNo }}</el-descriptions-item>
            <el-descriptions-item label="VIN代码">{{ basicInfo.VINCode }}</el-descriptions-item>
            <el-descriptions-item label="出厂编号">{{ basicInfo.ManufactureID }}</el-descriptions-item>
            <el-descriptions-item label="主减速比">{{ basicInfo.MainRatio }}</el-descriptions-item>
            <el-descriptions-item label="车型型号">{{ basicInfo.VelTypeName }}</el-descriptions-item>
            <el-descriptions-item label="轮胎型号">{{ basicInfo.TyreModel }}</el-descriptions-item>
            <!-- <el-descriptions-item label="最高车速">{{ basicInfo.MaxSpeed }}</el-descriptions-item>
            <el-descriptions-item label="限制车速">{{ basicInfo.LimitSpeed }}</el-descriptions-item> -->
            <el-descriptions-item label="驱动电机型号" v-if="fuelType === 1">{{ basicInfo.DriverElecMachineModel }}</el-descriptions-item>
            <el-descriptions-item label="电池类型" v-if="fuelType === 1">{{ basicInfo.BatteryType }}</el-descriptions-item>
            <el-descriptions-item label="电池容量" v-if="fuelType === 1">{{ basicInfo.BatteryCapacity }}</el-descriptions-item>
            <!-- <el-descriptions-item label="超级电容电压"></el-descriptions-item> -->
            <el-descriptions-item label="生产厂商" v-if="fuelType === 1">{{ basicInfo.BatteryManufacturer }}</el-descriptions-item>
            <el-descriptions-item label="变速箱类型">{{ basicInfo.GearBoxModel }}</el-descriptions-item>

        </el-descriptions>
    </div>
</template>
<script>
export default {
    props: {
        reportTime: {
            type: String,
            default: ''
        },
        basicInfo: {
            type: Object,
            default: () => ({})
        },
        fuelType: {
            type: Number,
            default: 1
        }
    }
}
</script>
<style scoped>
.vehicle-info {

    background: #ffffff;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}



/* 自定义描述列表样式，贴合截图视觉 */
.el-descriptions {
    --el-descriptions-item-label-width: 150px;
    /* 标签宽度统一 */
    --el-descriptions-item-label-align: center;
    /* 标签居中 */
    --el-descriptions-item-content-align: left;
    /* 内容左对齐 */
}

::v-deep .el-descriptions-item__cell {
    padding: 8px 10px !important;

}

::v-deep .el-descriptions-item__label {
    color: #000000 !important;
    font-weight: normal;
    background-color: #E2F0FF !important;


}

::v-deep .el-descriptions .is-bordered .el-descriptions-item__cell {
    border: 1px solid #A3C0E8 !important;
}
</style>